import React, { useEffect, useRef, useState } from 'react'

import ChartTabs from './ChartTabs'
import ChartControls from './ChartControls'
import TimeWindowDropdown from './TimeWindowDropdown'
import ParamDropdown from './sampleChart/ParamDropdown'
import ResetParamDropDown from './sampleChart/ResetParamDropdown'
import DetailSampleChart from './sampleChart/DetailSampleChart'
import DetailDepthChart from './depthProfile/DetailDepthChart'

const DetailChart = () => {
    const chartHeaderRef = useRef(null)
    const [headerHeight, setHeaderHeight] = useState(0)

    useEffect(() => {
        if (!chartHeaderRef.current) return

        const updateHeaderHeight = () => {
            setHeaderHeight(
                (chartHeaderRef.current &&
                    chartHeaderRef.current.offsetHeight) ||
                    0
            )
        }

        updateHeaderHeight()

        const resizeObserver = new ResizeObserver(updateHeaderHeight)
        resizeObserver.observe(chartHeaderRef.current)

        return () => {
            if (chartHeaderRef.current) {
                resizeObserver.unobserve(chartHeaderRef.current)
            }
        }
    }, [])

    return (
        <div>
            <div ref={chartHeaderRef} style={{ paddingBottom: 20 }}>
                <ChartTabs />
                <ChartControls />
                <ResetParamDropDown />
                <ParamDropdown />
                <TimeWindowDropdown />
            </div>
            <DetailSampleChart headerHeight={headerHeight} />
            <DetailDepthChart headerHeight={headerHeight} />
        </div>
    )
}

export default DetailChart
